var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnersArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87899 12.5C8.87884 12.3687 8.90465 12.2386 8.95493 12.1173C9.00521 11.9959 9.07898 11.8857 9.17199 11.793L13.4141 7.55031C13.6017 7.36279 13.856 7.25745 14.1212 7.25745C14.3864 7.25745 14.6407 7.36279 14.8282 7.55031C15.0157 7.73783 15.1211 7.99216 15.1211 8.25734C15.1211 8.52253 15.0157 8.77686 14.8282 8.96438L11.2931 12.5L14.8282 16.0357C15.0157 16.2232 15.1211 16.4775 15.1211 16.7427C15.1211 17.0079 15.0157 17.2622 14.8282 17.4497C14.6407 17.6372 14.3864 17.7426 14.1212 17.7426C13.856 17.7426 13.6017 17.6372 13.4142 17.4497L9.17196 13.207C9.07895 13.1143 9.00519 13.0041 8.95492 12.8828C8.90464 12.7614 8.87883 12.6314 8.87899 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersArrow);
export default __webpack_public_path__ + "static/media/PartnersArrow.4d73209b6926f375fd84cbc3d86fb9ea.svg";
export { ForwardRef as ReactComponent };